export default __webpack_public_path__ + "static/media/vertical.703a2031.png";